export const effectiveRateHeaders = [
  {
    text: "Rank",
    value: "rank"
  },
  {
    text: "Change",
    value: ""
  },
  {
    text: "Agent",
    value: "user"
  },
  {
    text: "Sales (CTM)",
    value: "ctm_sales_calls"
  },
  {
    text: "Sales (S360)",
    value: "s360_sales_calls"
  },
  {
    text: "Leads",
    value: "leads"
  },
  {
    text: "Reservations",
    value: "reservations"
  },
  {
    text: "Phone Rentals*",
    value: "phone_rentals"
  },
  {
    text: "Total Rentals",
    value: "total_rentals"
  },
  {
    text: "Pending",
    value: "pending"
  },
  {
    text: "Eff. Rate (CTM)",
    value: "ctm_effective_rate"
  },
  {
    text: "Eff. Rate (S360)",
    value: "s360_effective_rate"
  }
];
